import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@blueprint/ui';
import { DefaultTable } from '../Table/DefaultTable';

const StyledLink = styled(Link)`
    color: white;

    &:hover {
        text-decoration: underline;
        color: white;
    }
`;

const TypographyHover = styled(Typography)`
    &:hover {
        text-decoration: underline;
    }
`;

const columns = [
    { Header: 'Who else sets these cookies?', accessor: 'whoElseSetsTheseCookies' },
    { Header: 'For what purpose?', accessor: 'forWhatPurpose' },
];

const data = [
    {
        whoElseSetsTheseCookies: 'AppDynamics',
        forWhatPurpose: 'To provide us browser performance information in order that we can keep our websites running smoothly',
    },
];

const CookieNotice = () => {
    const { t } = useTranslation();
    return (
        <>
            <Box padding='100px 5vw 0px 5vw' paddingBottom='13em'>
                <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                    <Typography variant='h1' className='page-title' tabIndex='-1'>
                        {t('cookiePolicy.cookieNotice')}
                    </Typography>
                </Box>
                <Box display='flex' flexDirection='column' marginTop='1em' maxWidth='600px'>
                    <Box marginBottom='2em'>
                        <Typography variant='body1'>{t('cookiePolicy.theNoticeProvidesInformation')}</Typography>
                    </Box>
                    {/**/}
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.whatAreCookies')}
                        </Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <Typography variant='body1'>{t('cookiePolicy.cookiesAreSmallPieces')}</Typography>
                    </Box>
                    {/**/}
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.howWeUseCookies')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.theCookiesWeUseAre')}</Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <Typography variant='body1' marginBottom='1em'>
                            {t('cookiePolicy.weDontHaveToAsk')}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.cookiesThatHelpYouLogOn')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>
                            {t('cookiePolicy.weUseThisCookiesToRemember')}&nbsp;{t('cookiePolicy.youWontBeAbleToLogOn')}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1'></Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <Typography variant='body1'>{t('cookiePolicy.weWorkWithServiceProviders')}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.cookiesThatHelpYouProvide')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.coreServicesAndFeatures')}</Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.weWorkWithServiceProviders')}</Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <DefaultTable data={data} columns={columns} />
                    </Box>

                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.cookiesThatHelpKeepOurWebsiteSecure')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.weUseTheseCookiesToProtectTheSecurity')}</Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <Typography variant='body1'>{t('cookiePolicy.weWorkWithServiceProviders')}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.cookiesThatHelpUsDetectFraudOrCrime')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.weUsetTheseCookiesToHelpUsIdentifySuspiciousBehaviour')}</Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <Typography variant='body1'>{t('cookiePolicy.weWorkWithServiceProviders')}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.cookiesDurationAndYourBrowser')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.theLengthOfTime')}</Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.someOfOurPartners')}</Typography>
                    </Box>
                    <Box marginBottom='2em'>
                        <Typography variant='body1'>{t('cookiePolicy.youCanUseYourBrowserSettings')}</Typography>
                    </Box>
                    <Box>
                        <Typography variant='body1' fontWeight='bold'>
                            {t('cookiePolicy.cookiesAndYourPrivacy')}
                        </Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.theInformationCookiesCollect')}</Typography>
                    </Box>
                    <Box marginBottom='1em'>
                        <Typography variant='body1'>{t('cookiePolicy.youCanLearnMore')}</Typography>
                        <StyledLink target='_blank' to='/privacy-notice' aria-label={t('cookiePolicy.privacyNotice') + ' opens in a new window'}>
                            <TypographyHover variant='body1' style={{ color: '#23527C', textDecoration: 'underline' }}>
                                {t('cookiePolicy.privacyNotice')}
                            </TypographyHover>
                        </StyledLink>
                    </Box>
                </Box>
            </Box>
            <footer
                style={{
                    backgroundColor: 'black',
                    width: '100%',
                    position: 'absolute',
                    bottom: '0px',
                    left: '0px',
                }}
            >
                <Box marginLeft='4.2vw' marginRight='4.2vw' alignContent='center'>
                    <Typography variant='body1' style={{ color: 'white' }}>
                        {t('cookiePolicy.footerText')}
                    </Typography>
                </Box>
            </footer>
        </>
    );
};

export default CookieNotice;
